import "./UploadFile.css";
import { useState } from "react";
import { Modal } from "@mantine/core";
import { ReactComponent as CloseIcon } from "../../assets/iconamoon_close.svg";
import { ReactComponent as CircleTickIcon } from "../../assets/circle_tick.svg";
import { ReactComponent as UploadFileLogo } from "../../assets/uploadFileLogo.svg";
import { ReactComponent as DocumentUploded } from "../../assets/documentUploded.svg";
import CustomButton from "../CustomButton";
import { useDropzone } from "react-dropzone";

const UploadFile = ({ opened, close, onUpload }) => {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [openPopup, setOpenPopup] = useState(false);

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const newFile = acceptedFiles[0];
      setFile(newFile);
      setProgress(0);
      simulateUpload();
    }
  };

  const simulateUpload = () => {
    let progressValue = 0;
    const interval = setInterval(() => {
      progressValue += Math.floor(Math.random() * 10) + 5;
      setProgress((prev) => Math.min(prev + progressValue, 100));

      if (progressValue >= 100) {
        clearInterval(interval);
      }
    }, 300);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ".pdf,.docx,.jpg",
    maxSize: 10 * 1024 * 1024,
    multiple: false,
    onDrop,
  });

  const removeFile = () => {
    setFile(null);
    setProgress(0);
  };

  return (
    <div>
      <Modal
        opened={opened}
        onClose={close}
        centered
        radius="xl"
        size="sm"
        withCloseButton={false}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            padding: "20px",
          }}
        >
          <CloseIcon
            style={{
              position: "absolute",
              top: "24px",
              right: "24px",
              cursor: "pointer",
            }}
            onClick={() => {
              setFile(null);
              setProgress(0);
              close();
            }}
          />

          <div className="upload-file-container" style={{ paddingTop: "20px" }}>
            <h4 className="upload-file-heading">Upload file</h4>

            <div
              {...getRootProps()}
              className={`drop-area ${isDragActive ? "active" : ""}`}
            >
              <UploadFileLogo />
              <input {...getInputProps()} />
              <p>Click to upload or drag and drop</p>
              <p className="subtext" style={{ textAlign: "center" }}>
                Supported formats: PDF, DOCX, JPG. Max size: 10 MB.
              </p>
            </div>
            {file && (
              <div className="file-upload-box">
                <DocumentUploded />
                <div className="file-upload-box-container">
                  <p style={{ marginBottom: "0px" }} className="file-name">
                    {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                  </p>
                  <div className="progress-bar-container">
                    <div className="progress-bar">
                      <div
                        className="progress"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                    <p style={{ marginBottom: "0px" }} className="progress-text">{progress}%</p>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "12px",
              width: "100%",
            }}
          >
            <CustomButton
              btnText={"CANCEL"}
              type="secondary"
              flex={1}
              onClick={() => {
                setFile(null);
                setProgress(0);
                close();
              }}
            />
            <CustomButton
              btnText={"UPLOAD"}
              flex={1}
              onClick={() => {
                if (file && progress === 100) {
                  onUpload(file);
                  setOpenPopup(true);
                  close();
                }
              }}
            />
          </div>
        </div>
      </Modal>

      <Modal
        opened={openPopup}
        onClose={() => setOpenPopup(false)}
        centered
        radius={"xl"}
        size={"lg"}
        withCloseButton={false}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "30px",
            padding: "48px",
          }}
        >
          <CloseIcon
            style={{
              position: "absolute",
              top: "24px",
              right: "24px",
              cursor: "pointer",
            }}
            onClick={() => setOpenPopup(false)}
          />
          <CircleTickIcon />
          <h1
            className="header"
            style={{ color: "#314064", textAlign: "center" }}
          >
            File uploaded
          </h1>
          <p
            style={{ textAlign: "center", color: "#222222" }}
            className="sub-header"
          >
            Your file has been uploaded and is now being processed. You can
            proceed with the next steps or review the uploaded data.
          </p>
          <CustomButton
            style={{ width: "50%" }}
            btnText={"BACK TO DASHBOARD"}
            flex={1}
            onClick={() => setOpenPopup(false)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default UploadFile;
